"use client"
import { PauseIcon, PlayIcon, SpeakerWaveIcon, SpeakerXMarkIcon } from "@heroicons/react/24/outline"

import { useInView } from "motion/react"
import { useEffect, useRef, useState } from "react"
import ReactPlayer from "react-player/lazy"

export const VideoSectionBOTB = () => {
  const [isMounted, setIsMounted] = useState(false)
  const [muted, setMuted] = useState(true)
  const [volume, setVolume] = useState(0.5)
  const [paused, setPaused] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref)

  return (
    <div ref={ref} className="group relative flex w-full items-center justify-center overflow-hidden rounded-xl">
      {isMounted ? (
        <>
          <ReactPlayer
            width={"100%"}
            volume={muted ? 0 : volume}
            loop
            playing={inView && !paused}
            config={{
              file: {
                attributes: {
                  playsinline: true,
                },
              },
            }}
            height={"100%"}
            key="video"
            style={{
              aspectRatio: "1440/1080",
            }}
            url={`${process.env.NEXT_PUBLIC_NOVA_STATIC_CLOUDFRONT_DOMAIN}/marketing-site/botb-video/e257e69f-b7dd-45f6-9b04-3760156bd676.m3u8`}
          />

          <div className="group absolute bottom-0 right-0 flex items-center gap-2 p-5 transition-all group-hover:opacity-100 md:p-10 md:opacity-0">
            {!muted && (
              <input
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={volume}
                onChange={e => setVolume(parseFloat(e.target.value))}
                className="h-1 w-20 cursor-pointer appearance-none rounded-lg bg-marketing-primary-dark/30 opacity-0 group-hover:opacity-100 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-marketing-primary-dark"
              />
            )}
            <div
              onClick={() => setMuted(p => !p)}
              className="flex size-10 cursor-pointer items-center justify-center rounded-full bg-marketing-primary-dark/10">
              {muted ? (
                <SpeakerXMarkIcon className="size-6 stroke-marketing-primary-dark" />
              ) : (
                <SpeakerWaveIcon className="size-6 stroke-marketing-primary-dark" />
              )}
            </div>
            <div
              onClick={() => setPaused(p => !p)}
              className="flex size-10 cursor-pointer items-center justify-center rounded-full bg-marketing-primary-dark/10">
              {paused ? (
                <PlayIcon className="size-6 stroke-marketing-primary-dark" />
              ) : (
                <PauseIcon className="size-6 stroke-marketing-primary-dark" />
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  )
}
